export const canGenerateUUID = (): boolean => window.crypto?.randomUUID !== undefined

export const generateUUID = (): string => window.crypto?.randomUUID?.() || ''
